import SharedAllVariablesPage from "~/areas/projects/components/Variables/AllVariables/SharedAllVariablesPage";
export function AllVariablesPage() {
    return <SharedAllVariablesPage />;
}
